import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_role as ENUM } from '../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_GRID2D__view } from '../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__color_map } from '../../_invocations/image/INVOCATION_IMAGE__color_map';
import { INVOCATION_IMAGE__viewport } from '../../_invocations/image/INVOCATION_IMAGE__viewport';
import { ENUM__graph_template_name } from '../sd_1/ENUM__graph_template_name';

export function GENERATION_TOOL__vision__color_map() {
  /*
   *
   */

  let out = new DTO__generation_tool();
  out.name = ENUM__graph_template_name.CREATE_COLOR_MAP;

  const graph = DTO_GRAPH__instance.CREATE_NEW();
  out.graph = graph;

  /*
   * GRID2D
   */
  const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

  /*
   * VIEWPORT
   */

  /*
   * COLOR MAP
   */

  const node__color_map = INVOCATION_IMAGE__color_map.create_node_for(graph, ENUM.VISION__COLOR_MAP);
  graph.edge__try_add_for_fields(node__color_map.out, node__grid2d.image);

  const node__viewport = INVOCATION_IMAGE__viewport.CREATE_VIEWPORT_FOR(graph, node__color_map.image);

  /*
   * INPUT
   */

  /*
   * VIEW
   */

  let fields__visible: any[] = [node__viewport.image, node__color_map.tile_size];
  let field_column_id = node__color_map.tile_size.meta.field_id;

  out.view__add({ fields__visible, fields__stored: fields__visible, field_column_id });

  /*
   *
   */

  return out;
}
